import { useAtom } from 'jotai';
import { atom } from 'jotai';

// Atom to control the visibility of the chats overlay sidebar
const chatsSidebarAtom = atom(false);

/**
 * Hook to control the chats sidebar that appears when the user presses the
 * messages-square icon in the main sidebar.
 */
export function useChatsSidebar() {
  const [showChatsSidebar, setShowChatsSidebar] = useAtom(chatsSidebarAtom);
  return { showChatsSidebar, setShowChatsSidebar };
}
